import { useCallback } from "react";

import { createError, parseGraphQLError } from "utils";

import {
  useDeleteMeeting,
  useQueryClientMeetings,
  useQueryClientRecentMeetings,
} from ".";

export function useClientMeetings(clientId, onDelete) {
  const recentMeetings = useQueryClientRecentMeetings(clientId);
  const meetings = useQueryClientMeetings(clientId);
  const deleteMeeting = useDeleteMeeting(onDelete);

  const generateErrorMsg = useCallback((error, name) => {
    return createError({
      ...parseGraphQLError(error),
      name: name,
      defaultMessage:
        "Failed to load meetings. Please refresh the page or contact support for further assistance.",
    }).message;
  }, []);

  return {
    meetings: meetings,
    recentMeetings: recentMeetings,
    error:
      (meetings.error || recentMeetings.error) &&
      !meetings.loading &&
      !recentMeetings.loading
        ? generateErrorMsg(
            meetings.error || recentMeetings.error,
            meetings.error ? "GetClientMeetings" : "GetClientRecentMeetings"
          )
        : null,
    initialFetch:
      (meetings.loading && meetings.fetchCount === 0) ||
      (recentMeetings.loading && recentMeetings.fetchCount === 0),
    deleteMeeting: deleteMeeting,
  };
}

export default useClientMeetings;
